import React from 'react';
import { InputAdornment, TextField, TextFieldProps } from '@mui/material';
import { NumericFormat, NumericFormatProps, PatternFormat, PatternFormatProps } from 'react-number-format';

const renderNumericFormat = (props) => (
  <NumericFormat
    {...props}
    size="medium"
    color="primary"
    variant="standard"
    decimalScale={2}
    thousandSeparator="."
    decimalSeparator=","
    allowNegative={false}
  />
);

const renderPatternFormat = (props) => <PatternFormat {...props} size="medium" color="primary" variant={props?.variant || 'standard'} />;

interface IMaskedTextInputFormikProps {
  mode: 'currency' | 'cpf' | 'cnpj' | 'phone' | 'cep' | 'brPhone' | 'mobileAndLandline';
  name: string;
  value: string | number;
  onChange: (e) => void;
  error?: boolean;
  helperText?: string;
  label?: string;
  currencyPrefix?: string;
  startAdornment?: JSX.Element;
  endAdornment?: JSX.Element;
}

const MaskedTextInputFormik = ({
  mode,
  onChange,
  error,
  helperText,
  name,
  label,
  value,
  currencyPrefix = 'R$',
  startAdornment,
  endAdornment,
  disabled,
  ...restProps
}: IMaskedTextInputFormikProps & Partial<NumericFormatProps> & Partial<PatternFormatProps> & Partial<TextFieldProps>) => {
  const baseProps = {
    onChange,
    value,
    error,
    helperText,
    name,
    label,
    customInput: TextField,
    disabled,
    ...restProps,
  };

  switch (mode) {
    case 'currency':
      return renderNumericFormat({
        ...baseProps,
        decimalScale: 2,
        thousandSeparator: '.',
        decimalSeparator: ',',
        allowNegative: false,
        InputProps: {
          startAdornment: startAdornment || <InputAdornment position="start">{currencyPrefix}</InputAdornment>,
          endAdornment,
        },
      });

    case 'cpf':
      return renderPatternFormat({ ...baseProps, format: '###.###.###-##' });

    case 'cnpj':
      return renderPatternFormat({ ...baseProps, format: '##.###.###/####-##' });

    case 'phone':
      // TODO: Check phone format because of previous "9" digit variation
      return renderPatternFormat({ ...baseProps, format: '(##)####-####' });

    case 'brPhone':
      return renderPatternFormat({ ...baseProps, format: '(##)#####-####' });

    case 'cep':
      return renderPatternFormat({ ...baseProps, format: '#####-###' });

    default:
      return <div />;
  }
};

export default MaskedTextInputFormik;
